import React, { useContext, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router';
import { useDispatch } from 'react-redux';
import {
  ApiError,
  BadRequestError,
  NotFoundError,
  PageContext,
  useApiWithErrors,
} from '@axiom/ui';
import PropTypes from 'prop-types';

import {
  activateSideBar,
  openSideBar,
  deactivateSideDrawer,
} from '../redux/actions/app';
import DefaultLayout from '../layouts/default';
import { CandidatesList } from '../components/CandidatesList/CandidatesList';
import { CandidateFilters } from '../components/CandidateFilters/CandidateFilters';
import { CandidateUtil } from '../utils/candidate-util';
import { UserSearchesApi } from '../api/user-searches-api';
import { useSavedSearchFilters } from '../hooks/useSavedSearchFilters';
import { CandidateAiSearch } from '../components/CandidateAiSearch/CandidateAiSearch';

/**
 * @param {{ name?: string }} props
 */
export const TalentPage = ({ name } = {}) => {
  const savedFilters = useSavedSearchFilters();
  const [searchParams, setSearchParams] = useSearchParams();
  const dispatch = useDispatch();
  const { setTitle } = useContext(PageContext);
  setTitle('Talent List');

  const [filters, setFilters] = useState({
    ...CandidateUtil.getCandidatesListFilterDefaults(),
    ...savedFilters,
  });

  const showSavedSearchTab = !!searchParams.get('showSavedSearches');

  useEffect(() => {
    if (showSavedSearchTab) {
      dispatch(openSideBar());
      dispatch(deactivateSideDrawer());
      dispatch(activateSideBar());
    }
  }, [showSavedSearchTab, dispatch]);

  return (
    <DefaultLayout
      sidebarContent={
        <CandidateFilters
          filters={filters}
          onFilterChange={updatedFilters => {
            setFilters(updatedFilters);
          }}
          showSavedSearchTab={showSavedSearchTab}
        />
      }
      aiSearchContent={<CandidateAiSearch />}
    >
      <CandidatesList filters={filters} />
    </DefaultLayout>
  );
};

TalentPage.propTypes = {
  name: PropTypes.string,
};
